module.exports = __webpack_public_path__ + "img/tag_black_oval.23651e85.svg";